import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/about.scss";

const values = [
  {
    title: "Useful by design",
    copy: "Every object earns its place through a satisfying feel, dependable performance, and details that make it easier to use.",
  },
  {
    title: "Made to stay",
    copy: "We prefer refillable, repairable, and durable tools—the pieces that gather a history instead of becoming quick clutter.",
  },
  {
    title: "Curiosity first",
    copy: "Our collection makes room for many ways of thinking, from precise notes and loose sketches to plans that are still taking shape.",
  },
];

function About() {
  return (
    <main className="editorial-page about-page">
      <div className="editorial-page__inner">
        <header className="editorial-page__hero">
          <p className="editorial-page__eyebrow">Our story</p>
          <h1>Objects for ideas worth keeping.</h1>
          <p className="editorial-page__lede">
            {siteConfig.brandName} is an independent stationery shop for people
            who still believe the right tool can change the way a thought
            arrives.
          </p>
        </header>

        <div className="editorial-page__rule" aria-hidden="true" />

        <section className="editorial-page__section" aria-labelledby="about-origin">
          <p className="editorial-page__section-label">The beginning</p>
          <h2 id="about-origin">A slower kind of desk supply.</h2>
          <div className="editorial-page__copy">
            <p>
              We began with a simple observation: the tools closest to us often
              receive the least consideration. A pen is borrowed and forgotten.
              A notebook is bought in a rush. A desk fills with objects that work,
              but never quite feel right.
            </p>
            <p>
              {siteConfig.brandName} brings intention back to those everyday
              choices. We select writing, drawing, and planning tools for their
              balance, material, usefulness, and quiet character. Nothing needs
              to shout to deserve a permanent place on your desk.
            </p>
          </div>
        </section>

        <figure className="about-manifesto">
          <blockquote>
            “A good tool does not interrupt the idea. It gives the idea somewhere
            to land.”
          </blockquote>
          <figcaption>{siteConfig.brandTagline}</figcaption>
        </figure>

        <section className="editorial-page__section" aria-labelledby="about-values">
          <p className="editorial-page__section-label">What guides us</p>
          <h2 id="about-values">Considered from point to page.</h2>
          <div className="about-values">
            {values.map((value, index) => (
              <article className="about-value" key={value.title}>
                <span aria-hidden="true">0{index + 1}</span>
                <h3>{value.title}</h3>
                <p>{value.copy}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="about-closing" aria-labelledby="about-next">
          <p className="editorial-page__section-label">From our desk to yours</p>
          <h2 id="about-next">Find the tool that fits your way of thinking.</h2>
          <p>
            Curated in {siteConfig.contact.address}, our collection is made for
            daily rituals, fresh starts, and work in progress.
          </p>
          <div className="editorial-page__actions">
            <Link className="editorial-button" to="/shop">
              Explore the collection
            </Link>
            <Link className="editorial-text-link" to="/contact">
              Write to us <span aria-hidden="true">→</span>
            </Link>
          </div>
        </section>
      </div>
    </main>
  );
}

export default About;
